module.exports = __webpack_public_path__ + "img/winnings-hour.4a889c7f.png";